import React, { useState } from 'react';
// Components
import TimerComponent from '../TimerComponent';

import "./PixPaymentComponent.css";

const PixPaymentComponent = ({ pixPaymentData }) => {

    const { pixLoading, pixCodeToCopy, qrCode } = pixPaymentData;
    const [copied, setCopied] = useState(false);


    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(pixCodeToCopy);
            setCopied(true);
            setTimeout(() => setCopied(false), 5000); // Reseta a mensagem após 5 segundos
        } catch (err) {
            console.error('Erro ao copiar para a área de transferência: ', err);
        }
    };

    return (
        <div>

            <div className="container mt-3 ">
                <div className="row justify-content-center">
                    {pixLoading ? (
                        <p style={{ color: '#797979', fontFamily: 'Open Sans' }}>
                            <div className="spinner-grow text-success" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div> Gerando QRCode...</p>
                    ) : (

                        <>

                            {pixPaymentData.executePayment ? (
                                <>
                                    <div className="col-md-12 text-center">

                                        <p style={{ color: '#797979', fontFamily: 'Open Sans' }}>
                                            <div className="spinner-grow text-success" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div> Pedido aguardando pagamento via Pix</p>

                                        <p> Abra um aplicativo em que você tenha o Pix habilitado e escolha<br></br> a opção Pagar, em seguida Ler QR Code</p>

                                    </div>
                                    <div className="col-md-8 " style={{
                                        backgroundColor: '#F7F7F7',
                                        borderRadius: '10px',
                                        padding: '40px'
                                    }} >
                                        <div className="col-md-12 text-center " >
                                            <img src={qrCode} alt='qr-code' />
                                        </div>
                                    </div>
                                    <div className="col-md-8 text-center " >
                                        <p className="order-status__info-texts-title">Se preferir, copie o código abaixo ou utilize o Pix Copia e Cola no aplicativo que você vai fazer pagamento:</p>

                                    </div>
                                    <div className="col-md-8 pix-copy-area" style={{
                                        backgroundColor: '#F7F7F7',
                                        color: '#949494',
                                        borderRadius: '10px',
                                        padding: '10px'
                                    }}    >
                                        <div className='qr-code'>{pixCodeToCopy}</div>
                                        <div className={`copy ${copied ? '--copied' : ''}`} onClick={async () => handleCopy()}>Copiar</div>
                                    </div>

                                    <TimerComponent />
                                </>
                            ) : (
                                <div className="col-md-10 text-center" style={{
                                    padding: '10px',
                                    border: '1px #949494 solid',
                                    borderRadius: '14px'
                                }} >
                                    <p style={{
                                        padding: '10px',

                                    }}>
                                        <i className="bi bi-cash-coin" style={{ paddingRight: '20px', fontSize: '20px' }}></i>
                                        O Pagamento é imediato e feito em poucos cliques pelo seu celular.</p>

                                    <div className="col-md-12 text-center" style={{
                                        backgroundColor: '#FDF9F4',
                                        color: '#949494',
                                        borderRadius: '10px',
                                        padding: '10px'
                                    }} >
                                        <i className="bi bi-exclamation-circle" style={{ paddingRight: '20px' }}></i>
                                        O código Pix é gerado após clicar em Pagar Agora e tem validade de 10 Minutos.
                                    </div>
                                </div>
                            )}

                        </>
                    )}

                </div>
            </div>
        </div>
    )

};

export default PixPaymentComponent;